import { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import { useFeatureFlags } from "@/config/useFeatureFlags";
import { FreshnessChip } from "./FreshnessChip";
import { useBreadcrumbs } from "./BreadcrumbsContext";
import { UserMenu } from "./UserMenu";

// Class names mirror docs/ClaudeDesign/shell.tsx so the prototype CSS (.topbar, .brand-mini,
// .top-tabs, .top-tab, .user, .crumbs-row) applies. The "Info" tab opens the in-app dashboard
// guide and is available to every authenticated user.
export function Topbar() {
  const crumbs = useBreadcrumbs();
  const flags = useFeatureFlags();
  return (
    <header className="topbar">
      <div className="brand-mini">
        <div className="mark">G</div>
        <div className="name">
          OB 2.0 Analytics
          <small>GorillaWorks · FBO</small>
        </div>
      </div>
      <nav className="top-tabs" aria-label="Primary">
        {/* Operations leads for the people who have it: it is the daily-scrum screen and the landing page. */}
        {flags.operations && (
          <NavLink
            to="/operations"
            className={({ isActive }) => "top-tab " + (isActive ? "active" : "")}
          >
            Operations
          </NavLink>
        )}
        <NavLink
          to="/requests"
          className={({ isActive }) => "top-tab " + (isActive ? "active" : "")}
        >
          Requests
        </NavLink>
        <NavLink
          to="/tasks"
          className={({ isActive }) => "top-tab " + (isActive ? "active" : "")}
        >
          Tasks
        </NavLink>
        {flags.throughput && (
          <NavLink
            to="/throughput"
            className={({ isActive }) => "top-tab " + (isActive ? "active" : "")}
          >
            Throughput
          </NavLink>
        )}
        <NavLink
          to="/info"
          className={({ isActive }) => "top-tab " + (isActive ? "active" : "")}
        >
          Guide
        </NavLink>
      </nav>
      <div className="topbar-spacer" />
      <FreshnessChip />
      <UserMenu />
      {crumbs.length > 0 && (
        <div className="crumbs-row">
          <nav className="crumbs" aria-label="Breadcrumb">
            {crumbs.map((c, i) => (
              <Fragment key={i}>
                {i > 0 && (
                  <span
                    className="material-symbols-rounded sep"
                    style={{ fontSize: 14 }}
                    aria-hidden="true"
                  >
                    chevron_right
                  </span>
                )}
                {c.to ? (
                  <Link to={c.to}>{c.label}</Link>
                ) : (
                  <span className="current" aria-current="page">
                    {c.label}
                  </span>
                )}
              </Fragment>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
